import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/pkActivity',
  component: LAYOUT,
  name: 'pkActivity',
  redirect: '/pkActivity/detail',
  meta: {
    title: 'pk活动分享',
  },
  children: [
    {
      path: 'detail',
      name: 'PkActivityDetail',
      meta: {
        title: 'pk活动分享',
      },
      component: () => import('@/views/pkActivity/detail'),
    },
  ],
};
